import { render } from "./TopNavigation.vue?vue&type=template&id=fa6e6d32&scoped=true"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"

import "./TopNavigation.vue?vue&type=style&index=0&id=fa6e6d32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fa6e6d32"

export default script